import axios from "axios";

/**
 * Shared HTTP client for all backend calls.
 * Injects the auth token automatically so individual components never
 * read localStorage themselves (RainTest used to read the wrong key).
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001";

export const AUTH_TOKEN_KEY = "auth_token";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
